import { render, staticRenderFns } from "./DepartmentUserWindow.vue?vue&type=template&id=d482aac0&scoped=true&"
import script from "./DepartmentUserWindow.vue?vue&type=script&lang=js&"
export * from "./DepartmentUserWindow.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentUserWindow.vue?vue&type=style&index=0&id=d482aac0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d482aac0",
  null
  
)

export default component.exports